module.exports = __webpack_public_path__ + "03_medium_gold.a29f0a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_medium_gold.png
// module id = LfJc
// module chunks = 0